import * as PropTypes from "prop-types"
import styled from "styled-components"
import Faq from "./Faq"

const Wrapper = styled.div`
  background: white;
  padding: 0 10px;
  border-top: 1px solid ${({ theme }) => theme.colors.silver};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silver};
  @media ${({ theme }) => theme.breakpoints.lg} {
    padding: 0 25px;
  }
`

export default function FaqList({ list, page, closed }) {
  return (
    <Wrapper>
        {Object.keys(list).map(key => (
          <Faq key={key} question={list[key].question} answer={list[key].answer} page={page} closed={closed} />
        ))}
      </Wrapper>
  )
}

FaqList.defaultProps = {
  closed: false
}

FaqList.propTypes = {
  list: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  page: PropTypes.string.isRequired,
  closed: PropTypes.bool
}
